export default Object.freeze({
  ERROR_1800: 'FIRE-F1800',
  ERROR_1201: 'FIRE-F1201',
  ERROR_1200: 'FIRE-F1200',
  SUCCESS_CREATE: 'FIRE-S0001',
  SUCCESS_REQUEST: 'FIRE-S0000',
})
